import {
  EXPORT,
  IMPORT,
} from './order-types';

const PICKUP = 'pickup';
const DELIVER = 'deliver';

export const mapRequiresEquipment = order => (sequence) => {
  if (order.service_type === 'drop') {
    if (order.order_type === 'import' && sequence === 3) {
      return false;
    }
    if (order.order_type === 'export' && sequence === 1) {
      return false;
    }
  }
  return true;
};

export function getStopTypes(order) {
  const {
    order_type,
    movement_type,
  } = order;
  if (order_type === EXPORT) {
    return [
      {
        action: PICKUP,
        empty: true,
      },
      {
        action: PICKUP,
        empty: false,
      },
      {
        action: DELIVER,
        empty: false,
      },
    ];
  }

  if (order_type === IMPORT) {
    return [
      {
        action: PICKUP,
        empty: false,
      },
      {
        action: DELIVER,
        empty: false,
      },
      {
        action: DELIVER,
        empty: true,
      },
    ];
  }
  if (order_type === 'reposition') {
    return [
      {
        action: PICKUP,
        empty: true,
      },
      {
        action: DELIVER,
        empty: true,
      },
    ];
  }


  if (order_type === 'reload') {
    return [
      {
        action: PICKUP,
        empty: false,
      },
      {
        action: DELIVER,
        empty: false,
      },
    ];
  }


  // domestic
  if (movement_type === 'delivery') {
    return [
      {
        action: PICKUP,
        empty: false,
      },
      {
        action: DELIVER,
        empty: false,
      },
      {
        action: DELIVER,
        empty: true,
      },
    ];
  }

  return [
    {
      action: PICKUP,
      empty: true,
    },
    {
      action: PICKUP,
      empty: false,
    },
    {
      action: DELIVER,
      empty: false,
    },
  ];
}

export function getStopLocationTypes(order) {
  const {
    order_type,
  } = order;

  if (order_type === EXPORT) {
    return [
      'delivering',
      'arriving',
      'delivering',
    ];
  }

  return [
    'arriving',
    'delivering',
    'arriving',
  ];
}
